/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMeetingDecisionDto } from '../models/work-create-meeting-decision-dto';
import { WorkMeetingDecision } from '../models/work-meeting-decision';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMeetingDecisionDto } from '../models/work-update-meeting-decision-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingDecisionsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingDecisionsV2ControllerFindAllPaginated()` */
  static readonly MeetingDecisionsV2ControllerFindAllPaginatedPath = '/v2/meeting-decisions';

  /**
   * Required permissions: meeting-decisions:read, meeting-decisions:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingDecisionsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingDecisionsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>decidedAt</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'decidedAt:ASC' | 'decidedAt:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingDecision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingDecisionsV2Service.MeetingDecisionsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.meetingId', params['filter.meetingId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeetingDecision>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'meetingId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meeting-decisions:read, meeting-decisions:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingDecisionsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingDecisionsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>decidedAt</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'decidedAt:ASC' | 'decidedAt:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingDecision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
}> {
    return this.meetingDecisionsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingDecision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingDecision>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingDecisionsV2ControllerCreate()` */
  static readonly MeetingDecisionsV2ControllerCreatePath = '/v2/meeting-decisions';

  /**
   * Required permissions: meeting-decisions:create, meeting-decisions:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingDecisionsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingDecisionsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingDecisionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingDecision>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingDecisionsV2Service.MeetingDecisionsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingDecision>;
      })
    );
  }

  /**
   * Required permissions: meeting-decisions:create, meeting-decisions:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingDecisionsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingDecisionsV2ControllerCreate(
    params: {
      body: WorkCreateMeetingDecisionDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingDecision> {
    return this.meetingDecisionsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingDecision>): WorkMeetingDecision => r.body)
    );
  }

  /** Path part for operation `meetingDecisionsV2ControllerFindOneById()` */
  static readonly MeetingDecisionsV2ControllerFindOneByIdPath = '/v2/meeting-decisions/{id}';

  /**
   * Required permissions: meeting-decisions:read, meeting-decisions:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingDecisionsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingDecisionsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingDecision>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingDecisionsV2Service.MeetingDecisionsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingDecision>;
      })
    );
  }

  /**
   * Required permissions: meeting-decisions:read, meeting-decisions:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingDecisionsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingDecisionsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingDecision> {
    return this.meetingDecisionsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingDecision>): WorkMeetingDecision => r.body)
    );
  }

  /** Path part for operation `meetingDecisionsV2ControllerDelete()` */
  static readonly MeetingDecisionsV2ControllerDeletePath = '/v2/meeting-decisions/{id}';

  /**
   * Required permissions: meeting-decisions:delete, meeting-decisions:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingDecisionsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingDecisionsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingDecisionsV2Service.MeetingDecisionsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: meeting-decisions:delete, meeting-decisions:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingDecisionsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingDecisionsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.meetingDecisionsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `meetingDecisionsV2ControllerUpdate()` */
  static readonly MeetingDecisionsV2ControllerUpdatePath = '/v2/meeting-decisions/{id}';

  /**
   * Required permissions: meeting-decisions:update, meeting-decisions:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingDecisionsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingDecisionsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingDecisionDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingDecision>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingDecisionsV2Service.MeetingDecisionsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingDecision>;
      })
    );
  }

  /**
   * Required permissions: meeting-decisions:update, meeting-decisions:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingDecisionsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingDecisionsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingDecisionDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingDecision> {
    return this.meetingDecisionsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingDecision>): WorkMeetingDecision => r.body)
    );
  }

}
